import { ArrowLeft } from 'lucide-react'
import { ProfileForm } from './ProfileForm'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'
import { useNav } from './NavContext'
import StickyHeader from '@/app/features/reports/components/sticky-header'
import { useStickyHeaderContext } from '@/components/raytd/sticky-header-context'
import { cn } from '@/lib/utils'

const MobileProfilePage = () => {

    const navigate = useNavigate();
    const { navButtons } = useNav();
    const { isHeaderFixed } = useStickyHeaderContext();

    return (
        <div className="w-full flex flex-col gap-4">
            <StickyHeader offsetTop={0}>
                <nav className={cn("w-full flex justify-between py-3 px-4 transition-all duration-300 ease-in-out", {
                    "bg-zinc-100 border-b border-zinc-200": isHeaderFixed
                })}>
                    <Button variant="link" className="pl-0 gap-1 bg-transparent" onClick={() => navigate('/')}>
                        <ArrowLeft className="h-4 w-4" />
                        <span>Back</span>
                    </Button>
                    <div className="flex space-x-2 justify-center items-center">
                        {navButtons}
                    </div>
                </nav>
            </StickyHeader>
            <div className="p-6">
                <ProfileForm />
            </div>
        </div>
    )
}

export default MobileProfilePage

